module.exports = __webpack_public_path__ + "static/media/watch.026b7a08.svg";